module.exports = __webpack_public_path__ + "static/CircularStd-BookItalic-61889cfbb19d3a736ed1918d40c2b7ed.woff";